import { Component, ElementRef, Input, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { CellClickedEvent, ColDef, GridReadyEvent } from 'ag-grid-community';
import { UserProfile } from '../../interfaces/UserProfile';
import { AuthenticationService } from '../../services/authentication.service';
import { DateTime } from 'luxon';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CellTwoButtonRendererComponent } from '../cellrenderers/cell-two-button-renderer/cell-two-button-renderer.component';
import RenderDriverReportRequest from '../../interfaces/renderReportRequest';
import { DriverReportView } from '../../interfaces/driverReportView';
import { RecordsService } from '../../services/records.service';
import { DriverDashboardRecord } from '../../interfaces/driverDashboardRecord';

import { DriverRecordRequestService } from '../../services/driverrecordrequest.service';
import { TranslatorService } from '../../services/translator.service';
import { GeneralService } from '../../services/general.service';

@Component({
    selector: 'app-driver-dashboard-grid',
    templateUrl: './driver-dashboard-grid.component.html',
    styleUrls: ['./driver-dashboard-grid.component.scss'],
    standalone: false
})
export class DriverDashboardGridComponent {

     columnDefs: [] | any = [];
     useMockData: boolean = false;
     startRow: number = 1;
     pageSize: number = 8000;
     sortCol: string = 'RequestedDate';
     sortDir: string = 'desc';
     gridOptions: any = {};
     defaultColDef: any = {
          resizable: true,
          debug: true,
          rowSelection: 'multiple',
          paginationAutoPageSize: true,
          pagination: true,
          wrapText: true
     };
     frameworkComponents: any;
     loadingCellRenderer: any;
     loadingCellRendererParams: any;
     overlayLoadingTemplate: any;
     overlayNoRowsTemplate: any;
     domLayout: any;
     colResizeDefault: any;
     voodooComplete: boolean = false;
     gridLanguage: string = '';
     lang: string = '';
     isLoading: boolean = true;
     username: string = '';
     userProfile: UserProfile | undefined;
     authMethod: string = 'Login.gov';
     accessedVia: string = 'DriverDashboard';
     customerId: string = '2147483647';
     gridData: any = {};
     rowData$: DriverDashboardRecord[] = [];
     loadingText: string = '';
     noRowsText: string = '';
     requestDateHeader: string = '';
     lastNameHeader: string = '';
     licenseNumberHeader: string = '';
     stateHeader: string = '';
     actionsHeader: string = '';
     viewButtonText: string = '';
     expiredText: string = '';
     downloadButtonText: string = '';

     @ViewChild('pageVooDoo')
     footerArea: ElementRef | undefined;

     constructor (
          private authenticationService: AuthenticationService,
          public router: Router,
          private recordsService: RecordsService,
          public driverRecordRequestService: DriverRecordRequestService,
          public translationService: TranslatorService,
          public generalService: GeneralService) {

          this.userProfile = this.authenticationService.getUserProfile() as UserProfile;

          this.getColumnDefs().then((r) => this.loadColumnDefs(r));
          this.lang = this.translationService.getActiveLanguage().toUpperCase();
          this.updateTranslatedText(this);
          this.overlayLoadingTemplate = `<span class="ag-overlay-loading-center">${this.loadingText}</span>`;
          this.overlayNoRowsTemplate = `<span><em>${this.noRowsText}</em></span>`;
          this.domLayout = 'autoHeight';
          this.defaultColDef = { resizable: true };
     }

     // ********************** Lifecycle Events ********************** //
     ngOnInit(): void {
          //detect language change
          this.translationService._hasChanges$.subscribe(newValue => {
               if (newValue === true) {
                    this.translationService.restHasChange();
                    this.lang = this.translationService.getActiveLanguage().toUpperCase();
                    this.populateRecords();
               }
          });

          this.username = this.authenticationService.getUserName();
          this.gridOptions.gridApi = this.gridOptions.api;
          this.gridOptions.gridColumnApi = this.gridOptions.columnApi;
          this.gridLanguage = this.translationService.getActiveLanguage().toUpperCase();;
          this.gridLanguage = this.translationService.getActiveLanguage().toUpperCase();
          this.getColumnDefs().then((r) => this.loadColumnDefs(r));
     }

     loadColumnDefs(r: any) {
          if (r !== undefined) {
               this.columnDefs = r;
               console.log('this.columnDefs.length:' + this.columnDefs.length)
               for (let v = 0; v < this.columnDefs.length; v++) {
                    console.log('-- ' + this.columnDefs[v].headerName)
               }
          }
     }

     onGridReady(params: any) {
          this.populateRecords();          
     }

     // ********************** Grid Data ********************** //
     rowData: any = {
          getRows: (params: any) => {
               this.populateRecords();
          }
     }

     refreshGrid(scope: any) {
          this.isLoading = true;
          const recordsPromise = this.recordsService.getRecords(this.startRow, this.pageSize, this.sortCol, this.sortDir, this.username);
          recordsPromise
               .then((response: any) => {
                    this.gridData = [];
                    this.rowData$ = [];
                    if (response) {
                         this.gridData = response;
                         this.rowData$ = response!.items;
                    }

                    if (this.footerArea) {
                         this.generalService.gridFooterTxt(this.footerArea as ElementRef);
                    }
                    return this.rowData$;    
               })
               .catch((error: any) => {
                    console.error(error);
                    this.gridData = [];
                    this.rowData$ = [];
                    return this.rowData$;
               });
  
          this.getColumnDefs().then((r) => this.loadColumnDefs(r));
  
          this.lang = this.translationService.getActiveLanguage().toUpperCase();;
          this.updateTranslatedText(this);
          this.overlayLoadingTemplate = `<span class="ag-overlay-loading-center">${this.loadingText}</span>`;
          this.overlayNoRowsTemplate = `<span><em>${this.noRowsText}</em></span>`;
          this.domLayout = 'autoHeight';
          this.defaultColDef = { resizable: true };
          setTimeout(function () {
              scope.smartSizeColumns();
          }, 2000);
          
          this.isLoading = false;
      }

     populateRecords(): any {
          const recordsPromise = this.recordsService.getRecords(this.startRow, this.pageSize, this.sortCol, this.sortDir, this.username);
          recordsPromise
               .then((response: any) => {
                    this.gridData = [];
                    this.rowData$ = [];
                    if (response) {
                         this.gridData = response;
                         this.rowData$ = response!.items;
                    }

                    if (this.footerArea) {
                         this.generalService.gridFooterTxt(this.footerArea as ElementRef);
                    }
                    this.isLoading = false;
                    return this.rowData$;    
               })
               .catch((error: any) => {
                    console.error(error);
                    this.gridData = [];
                    this.rowData$ = [];
                    this.isLoading = false;
                    return this.rowData$;
               });
     }

     async getColumnDefs() {
          const componentScope = this;
          componentScope.lang = componentScope.translationService.getActiveLanguage().toUpperCase();
          componentScope.updateTranslatedText(componentScope);

          const promise = new Promise((resolve, reject) => {

               const expired: DateTime = DateTime.now()
                    .minus({ hours: Number(environment.APP_DRIVER_RECORD_EXPIRATION_HOURS) })
                    .endOf('hour');

               let records = [
                    {
                         headerName: componentScope.requestDateHeader,
                         field: 'requestedDate',
                         valueFormatter: (params: any) => this.formatDate(params),
                         sortable: true,
                         minWidth: 155,
                         maxWidth: 180,
                         flex: 2,
                    },
                    {
                         headerName: componentScope.lastNameHeader,
                         field: 'lastName',
                         sortable: true,
                         minWidth: 155,
                         maxWidth: 180,
                         flex: 2,
                    },
                    {
                         headerName: componentScope.licenseNumberHeader,
                         field: 'driverLicenseNumber',
                         tooltipField: 'driverLicenseNumber',
                         sortable: true,
                         minWidth: 100,
                         flex: 2,
                         resizable: true,
                    },
                    {
                         headerName: componentScope.stateHeader,
                         field: 'driverLicenseState',
                         sortable: true,
                         minWidth: 85,
                         maxWidth: 85,
                         flex: 2,
                    },
                    {
                         headerName: componentScope.actionsHeader,
                         field: 'authCode',
                         sortable: false,
                         minWidth: 200,
                         flex: 2,
                         suppressSizeToFit: false,
                         cellRenderer: CellTwoButtonRendererComponent,
                         cellRendererParams: {
                              buttonText: componentScope.viewButtonText,
                              buttonTitle: componentScope.viewButtonText,
                              buttonName: function (params: any) {
                                   return 'view' + params.value;
                              },
                              buttonClass: 'btn btn-primary btn-sm mt-n1 me-2',
                              hideButton: function (params: any) {
                                   const requestDate = DateTime.fromFormat(params!.data!.requestedDate, "yyyy-MM-dd'T'HH:mm:ss");
                                   if (requestDate < expired) {
                                        
                                        /* HIDE BUTTON if: transaction is expired */
                                        return true;
                                   } else {
                                        return false;
                                   }
                              },
                              hideButtonText: componentScope.expiredText,
                              buttonClick: function (authCode: string) {
                                   const request: RenderDriverReportRequest = { asPdf: false, authCode: authCode, driverIP: '' };
                                   componentScope.driverRecordRequestService.getEndUserIp()
                                        .then((result: any) => {
                                             request.driverIP = result;
                                             const reportView: DriverReportView = {
                                                  accessedVia: componentScope.accessedVia,
                                                  accessedBy: componentScope.username,
                                                  accessorCustomerId: '2147483647',
                                                  authCode: authCode,
                                                  authenticationMethod: componentScope.authMethod,
                                                  accessedDateTime: DateTime.now().toJSDate()
                                             }
                                             componentScope.driverRecordRequestService.openDriverReport(request, reportView)
                                                  .then((v: string | any) => {
                                                       componentScope.openInBrowser(v);
                                                  })
                                                  .catch((error: any) => {
                                                       console.error(error);
                                                  });
                                        }).catch((error: any) => {
                                             console.error(error);
                                             const reportView: DriverReportView = {
                                                  accessedVia: componentScope.accessedVia,
                                                  accessedBy: componentScope.username,
                                                  accessorCustomerId: '2147483647',
                                                  authCode: authCode,
                                                  authenticationMethod: componentScope.authMethod,
                                                  accessedDateTime: DateTime.now().toJSDate()
                                             }
                                             componentScope.driverRecordRequestService.openDriverReport(request, reportView)
                                                  .then((v: string | any) => {
                                                       componentScope.openInBrowser(v);
                                                  })
                                                  .catch((error: any) => {
                                                       console.error(error);
                                                  });
                                        });
                              },
                              button2Text: componentScope.downloadButtonText,
                              button2Title: componentScope.downloadButtonText,
                              button2Name: 'download',
                              button2Class: 'btn btn-outline-primary btn-sm mt-n1',
                              hideButton2: function (params: any) {
                                   if (DateTime.fromFormat(params!.data!.requestedDate, "yyyy-MM-dd'T'HH:mm:ss") < expired) {
                                        /* HIDE BUTTON if: transaction is expired */
                                        return true;
                                   } else {
                                        return false;
                                   }
                              },                             
                              button2Click: function (authCode: string) {
                                   const reportView: DriverReportView = {
                                        accessedVia: componentScope.accessedVia,
                                        accessedBy: componentScope.username,
                                        accessorCustomerId: '2147483647',
                                        authCode: authCode,
                                        authenticationMethod: componentScope.authMethod,
                                        accessedDateTime: DateTime.now().toJSDate()
                                   }
                                   componentScope.driverRecordRequestService.getDriverReportPdf(authCode, reportView)
                                        .then((v: any) => componentScope.openPdf(v))
                                        .catch((error: any) => {
                                             console.error(error);
                                        });
                              },
                         }
                    },
               ];
               resolve(records);
          });
          return await promise;
     }

     cleanModel() {
          const voodoo = null;
          if (voodoo) {
               const document: Document = (voodoo as HTMLElement).ownerDocument;
               const agUnselectableClassed: NodeListOf<HTMLElement> = document.querySelectorAll('.ag-body-horizontal-scroll, .ag-overlay');
               agUnselectableClassed.forEach((el: HTMLElement) => {
                    el.removeAttribute('aria-hidden')
               });
          }
     }

     // ********************** Open Driver Reports ********************** //
     openInBrowser(contentToRender: string) {
          if (contentToRender && contentToRender.length === 0) {
               this.router.navigateByUrl('/customerSupportInfo');
          }
          const newWindow = window.open();
          if (newWindow) {
               newWindow.document.title = this.translate('DriverRecordTitle');
               newWindow.document.write(contentToRender);
               newWindow.document.close();
               newWindow.focus()
          }
     }

     openPdf(buffer: any) {
          const filename = "DriverReport.pdf";
          const element = document.createElement('a');
          element.setAttribute('href', 'data:application/octet-stream;base64,' + buffer);
          element.setAttribute('download', filename);
          element.style.display = 'none';
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
     }

     // ********************** Formatting ********************** //
     formatDate(params: any) {
          if (params.value && params.value !== '') {
               return DateTime.fromISO(params.value).toFormat('MM/dd/yyyy');
          }
          return '';
     }

     smartSizeColumns() {
          const skipHeaders: boolean = true;
          this.gridOptions.gridApi = this.gridOptions.api;
          this.gridOptions.gridColumnApi = this.gridOptions.columnApi;

          const colApi = this.gridOptions.columnApi;
          const allColumnIds: number[] = [];
          if (colApi) {
               colApi.getColumns().forEach(function (column: any) {
                    if (column.colId === 'driverLicenseState') {
                         if (innerWidth < 700) {
                              colApi.setColumnVisible(column.colId, false);
                         } else {
                              colApi.setColumnVisible(column.colId, true);
                         }
                    }
                    if (column.colId === 'driverLicenseNumber') {
                         if (innerWidth < 600) {
                              colApi.setColumnVisible(column.colId, false);
                         } else {
                              colApi.setColumnVisible(column.colId, true);
                         }
                    }
                    if (column.colId === 'lastName') {
                         if (innerWidth < 500) {
                              colApi.setColumnVisible(column.colId, false);
                         } else {
                              colApi.setColumnVisible(column.colId, true);
                         }
                    }
                    allColumnIds.push(column.colId);
               });

               colApi.autoSizeColumns(allColumnIds, skipHeaders);
          }
          if (this.gridOptions.api) {
               this.gridOptions.api.sizeColumnsToFit();
          }
     }

     translate(translationTag: string) {
          this.lang  = this.translationService.getActiveLanguage().toUpperCase();;

          if (translationTag === 'Voodoo' && this.gridLanguage !== this.lang as string) {
               // Language has changed
               this.gridLanguage = this.lang;
               this.populateRecords();
               this.getColumnDefs().then((r) => this.loadColumnDefs(r));
               this.updateTranslatedText(this);
               this.overlayLoadingTemplate = `<span class="ag-overlay-loading-center">${this.loadingText}</span>`;
               this.overlayNoRowsTemplate = `<span><em>${this.noRowsText}</em></span>`;
               this.domLayout = 'autoHeight';
               this.defaultColDef = { resizable: true };

               this.smartSizeColumns();

               if (this.footerArea) {
                    this.generalService.gridFooterTxt(this.footerArea as ElementRef);
               }
          }
          return this.doTranslation(translationTag);
     }

     doTranslation(translationTag: string): string {
          let translatedText: string = this.generalService.getTranslation(translationTag, 'customer')
          if (translatedText === undefined) {
               translatedText = this.generalService.getTranslation(translationTag, 'customer');
          }
          return translatedText;
     }

     ngAfterViewInit(){
          const ngGridElement1 = document.querySelector<HTMLElement>('.ag-root')!;
          ngGridElement1.setAttribute('aria-busy','true');
     }

     private updateTranslatedText(scope: any) {
          if (scope.lang === 'ES'){
               scope.noRowsText = 'No se han encontrado resultados';
               scope.loadingText = 'Cargando...';
               scope.requestDateHeader = 'Fecha de solicitud';
               scope.lastNameHeader = 'Apellido';
               scope.licenseNumberHeader ='Licencia';
               scope.stateHeader = 'Estado';
               scope.actionsHeader = 'Acción';
               scope.viewButtonText = 'Ver';
               scope.expiredText = 'Caducado';
               scope.downloadButtonText = 'Descargar';
          } else if (scope.lang === 'FR') {
               scope.noRowsText = 'Aucun résultat trouvé';
               scope.loadingText = 'Chargement...';
               scope.requestDateHeader = 'Date de la demande';
               scope.lastNameHeader = 'Nom de famille';
               scope.licenseNumberHeader ='Numéro de permis';
               scope.stateHeader = 'État';
               scope.actionsHeader = 'Action';
               scope.viewButtonText = 'Afficher';
               scope.expiredText = 'Expiré';
               scope.downloadButtonText = 'Télécharger';
          } else {
               scope.noRowsText = 'No results found';
               scope.loadingText = 'Loading...';
               scope.requestDateHeader = 'Request Date';
               scope.lastNameHeader = 'Last Name';
               scope.licenseNumberHeader = 'License #';
               scope.stateHeader = 'State';
               scope.actionsHeader = 'Actions';
               scope.viewButtonText = 'View';
               scope.expiredText = 'Expired';
               scope.downloadButtonText = 'Download';
          }
     }
}
